// extracted by mini-css-extract-plugin
module.exports = {"gridForm":"ColumnMapping_gridForm__2B7NQ"};